require('resource_folders')
require('resource_collections')
require('problem_modal_events')
require('mobile_helpers')
require('share')
require('resources/stores/resource_store')
require('resources/resource_modal')

import lazyAssetsObserver from 'js/lib/lazy_assets';
import posthog from 'posthog-js';
import { PH_EVENTS } from 'js/posthog_analytics'
import HowdyBoxStatic from 'js/searches/howdy_box/howdy_box_static';

CommonCoreInfo     = LP.module 'CommonCoreInfo'
NotificationHelper = LP.module 'NotificationHelper'
Resources          = LP.module 'Resources'
Collections        = LP.module 'Collections'
RemoteHelper       = LP.module 'RemoteHelper'
ModalHooks         = LP.module 'ModalHooks'
Searches           = LP.module 'Searches'
DriveDocuments    = LP.module('DriveDocuments')

import AddToFoldersButton from 'js/add_to_folder/button'

LP.module('ProprietaryResources', Resources);

Resources.relatedDropdownInit = ->
  $rd = $('#related-dropdown')
  $rd.find('.dropdown-menu').on 'click', 'a', ->
    $rd.find('button.dropdown-toggle:visible').html $(this).text() + ' <span class="caret"></span>'
    $rd.removeClass 'open'

Resources.show_membership_locked = ->
  @show()
  return

Resources.show = ->
  lazyAssetsObserver.observe()
  # iPAD
  window.onunload = (e) ->
    window.scrollTo(0, 0)

  # Desktops. Chrome.
  window.onbeforeunload = (e) ->
    window.scrollTo(0, 0)

  $('#js-additional-materials a').tooltip()


  @initAddToFoldersButton($('.add-to-folders-btn:visible')[0])
  @bindPopovers()
  @relatedDropdownInit()
  @addToFavoritesSuccessCallback()
  @initRelatedCollections()
  @initEducatorRatings()
  @addOnClickEventToGoToButton()
  LP.module("Analytics").trackVirtualPageSuccess()

  posthog.capture(PH_EVENTS.SITE.VISITED_RRP)

  LP.module('Popovers').init()
  LP.module('Share').bindRRPShareButtons()

  # CM does not have searches.js included
  if Searches.hasOwnProperty('initializeTooltip')
    # For related resources. Visitor RRP does not have related resources displayed.
    Searches.initializeTooltip() if LP.config.logged_in

  LP.module('Dropdowns').toggleOnRemoteLinks()
  LP.module('ProblemModalEvents').init()
  LP.module('MobileHelpers').bindBackToTopButton()

  # IN MODAL - we need to trigger this after the resources.css loads.
  setTimeout (->
    LP.bindRRPToggle()
    Resources.bindTextOverview()
  ), 100

  @bindOpenCollectionLinkFromResourceModal()

  if LP.config.ai_teachers_tools_howdy_box_enabled
    howdyBoxContainer = document.getElementById('howdy-box');
    ReactDOM.createRoot(howdyBoxContainer).render(
      React.createElement(HowdyBoxStatic)
    );

Resources.windowObjectReference = null
Resources.openPopup = (url, windowName) ->
  if not Resources.windowObjectReference? or Resources.windowObjectReference.closed
    Resources.windowObjectReference = window.open(url, windowName, "resizable,scrollbars,status")
  else
    Resources.windowObjectReference.focus()

Resources.bindPopovers = ->
  $('.js-cc-popover:not(.lp-filter-item)').each ->
    $this = $(this)
    $more = $('<a href="javascript:void(0)" class="show-more-standards more">Show More</a>')
    $less = $('<a href="javascript:void(0)" class="show-more-standards less">Show Less</a>')
    $more.on 'click', ->
      $this.removeClass('with-max-height')

    $less.on 'click', ->
      $this.addClass('with-max-height')

    if ($this.height() >= 84)
      $this.addClass('with-max-height')
      $this.addClass('with-more-less-toggle')
      $this.after($less)
      $this.after($more)

  CommonCoreInfo.popovers('.js-cc-popover a.btn-standard')
  $('.js-resource-row [data-toggle="popover"]').popover(sanitize: false)

Resources.bindTextOverview = ->
  textOverview = $('.text-overview')
  return unless textOverview.length

  if textOverview.height() == +$('.text-overview').css('maxHeight').replace('px', '')
    textOverview.addClass('clamped')
    $('.js-more-overview').show().on 'click', (e) ->
      e.preventDefault()
      textOverview.removeClass('clamped')
      textOverview.css('maxHeight', 'none')
      $(@).hide()

Resources.initRelatedCollections = ->
  $root = $('.resource:not(.group-row), .drive_document:not(.group-row)')
  if $root.find('.collections-slider').length > 0
    @relatedCollections = new @ResourceCollections($root)
    @relatedCollections.activate()
  if $root.find('.folder-slider').length > 0
    @relatedFolders = new @ResourceFolders($root)
    @relatedFolders.activate()

Resources.addToFavoritesSuccessCallback = ->
  $('.js-resource-row .trk-save-resource').on 'ajax:success', (e, data) ->
    # 1. Update Favorites folder from CM.
    if LP.config.new_curriculum_manager
      LP.module('MyCurriculumManagerBase').triggerCurriculumManagerUpdate({ id: 1, type: 'folder', expand: false })

Resources.bindOpenCollectionLinkFromResourceModal= ->
  classes = '.collection-card .collection-rrp-link'
  $(document).off('click touch touchstart', classes)
  $(document).on 'click touch touchstart', classes, (e) ->
    e.preventDefault()
    e.stopPropagation()
    if open_in = e.currentTarget.getAttribute('data-open-in')
      data = $(e.currentTarget).data()
      LinkOpener.openResource(e.currentTarget.href, open_in, e, data)
    else if href = e.currentTarget.getAttribute('href')
      if e.currentTarget.getAttribute('target') == '_blank'
        window.open(href, '_blank')
      else
        window.location.href = href

Resources.initEducatorRatings = ->
  `import(/* webpackChunkName: 'educator-ratings' */ 'educator_ratings')`.then((module) ->
    module.default.init()
  );

DriveDocuments.show = ->
  Resources.show()

Resources.initAddToFoldersButton = (root) ->
  if LP.config.logged_in && root
    ReactDOM.createRoot(root).render(
      React.createElement(AddToFoldersButton, { url: root.getAttribute('data-url') })
    );

Resources.addOnClickEventToGoToButton = () ->
  root = $('.resource:not(.group-row), .drive_document:not(.group-row)')
  root.find('.btn.trk-goto-resource').on 'click', () ->
    posthog.capture(PH_EVENTS.SITE.GO_TO_RESOURCE)
